module.exports = __webpack_public_path__ + "static/media/commitment-menu.661f8860.svg";